export default "__VITE_ASSET__01dc0c39__"